import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { ClusterTiles, type Props } from '../components/ClusterTiles'
import { ScreenClassProvider } from '@vp/swan'
import { I18nextProvider } from 'react-i18next'
import { TrackingProvider } from '../hooks/TrackingContext'
import i18n from '../i18n/config'

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(
    <I18nextProvider i18n={i18n}>
      <TrackingProvider canonicalUrl='https://www.vistaprint.com'>
        <ScreenClassProvider>
          <ClusterTiles {...renderProps} />
        </ScreenClassProvider>
      </TrackingProvider>
    </I18nextProvider>
    , rootElement, rootOptions)
}
